<template>
    <div class="content" v-loading="loading" element-loading-text="数据同步中..." element-loading-spinner="el-icon-loading">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="单位名称:" prop="dwmc">
                        <el-input
                        v-model="queryParams.dwmc"
                        placeholder="请输入单位名称"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="专业类别:" prop="zylb">
                        <el-select v-model="queryParams.zylb" clearable placeholder="请选择专业类别" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="库别:" >
                        <el-checkbox-group v-model="checkList" @change="getCheck()">
                            <el-checkbox label="有效库"></el-checkbox>
                            <el-checkbox label="无证库"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <el-button type="danger"  v-if="xz=='1'" icon="el-icon-add" size="small" @click="handleAdd">新增被监管对象</el-button>
                        <el-button type="warning" size="small" @click="getTb">数据同步</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <p>单位数量:{{total}}</p>
            </div>
            <div class="box-cont">
                <el-table :data="xdrList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="监督对象名称" prop="dwmc" />
                    <el-table-column label="许可证号" prop="xkzh" />
                    <el-table-column label="单位地址" prop="dwdz" />
                    <el-table-column label="负责人" align="center" prop="jingyingzheXm" width="120"  />
                    <el-table-column label="手机1" align="center" prop="sj1" />
                    <el-table-column label="监督数" align="center" prop="jds" width="80"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.jds" style="color: #ff0000;"><b>{{scope.row.jds}}</b></span>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width"  width="140" >
                        <template slot-scope="scope">
                            <el-button 
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row)" style="margin-right:20px;"
                        >编辑</el-button>
                            <el-button v-if="sc=='1'"
                            size="small"
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="勾选" align="center" class-name="small-padding fixed-width" width="80" >
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleSelect(scope.row)"
                        >勾选</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>


        <el-dialog title="新增被监管对象" :visible.sync="open" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <h2 style="text-align:center;margin-bottom:10px;">当事人基本信息</h2>
                <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                    <el-row>
                        <el-col :span="12">
                    <el-form-item label="性质:" prop="jingyingzhe">
                        <el-select v-model="form.jingyingzhe" placeholder="请选择" clearable size="small">
                            <el-option 
                                v-for="dict in jingyingzheOptions"
                                :key="dict.id"
                                :label="dict.jingyingzhe"
                                :value="dict.jingyingzhe"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item :label="form.jingyingzhe?(form.jingyingzhe=='个人'?'个人姓名:':form.jingyingzhe+':'):'负责人:'" prop="jingyingzheXm">
                        <el-input v-model="form.jingyingzheXm" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="职务:">
                        <el-input v-model="form.frzw" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别:" prop="frxb">
                        <el-select v-model="form.frxb" placeholder="请选择性别" clearable size="small">
                            <el-option  label="男" value="男"/>
                            <el-option  label="女" value="女"/>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="单位名称:">
                        <el-input v-model="form.dwmc" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item label="地址:" prop="dwdz">
                        <el-input v-model="form.dwdz" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                    <el-form-item label="所在区域:" prop="qy">
                        <el-select v-model="form.qy" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in qyOptions"
                                :key="dict.ID"
                                :label="dict.CITY"
                                :value="dict.CITY"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :span="12">
                    <el-form-item label="联系方式:" prop="sj1">
                        <el-input
                        v-model="form.sj1"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="专业类别:">
                        <el-select v-model="form.zylb" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                    <el-form-item label="专业子类别:" prop="zyzlb">
                        <el-select v-model="form.zyzlb" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col> -->
                        <!-- <el-col :span="12">
                    <el-form-item label="工作部门:" prop="gzbm">
                        <el-select v-model="form.gzbm" placeholder="请选择" size="small">
                            <el-option
                                v-for="dict in gzbmOptions"
                                :key="dict.ID"
                                :label="dict.gzbm"
                                :value="dict.gzbm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                    <el-form-item label="统一社会信用代码:" prop="zzdm">
                        <el-input v-model="form.zzdm" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <!--<el-col :span="12">
                    <el-form-item label="经济类型:" prop="jjlx">
                        <el-select v-model="form.jjlx" placeholder="请选择" size="small">
                            <el-option label="全部"  value="全部"></el-option>
                            <el-option label="国有经济(公有)"  value="国有经济(公有)"></el-option>
                            <el-option label="集体经济(公有)"  value="集体经济(公有)"></el-option>
                            <el-option label="私营经济"  value="私营经济"></el-option>
                            <el-option label="个体经济"  value="个体经济"></el-option>
                            <el-option label="港澳台投资经济"  value="港澳台投资经济"></el-option>
                            <el-option label="股份制经济"  value="股份制经济"></el-option>
                            <el-option label="外商投资经济"  value="外商投资经济"></el-option>
                            <el-option label="联营经济"  value="联营经济"></el-option>
                            <el-option label="其它经济"  value="其它经济"></el-option>
                        </el-select>
                    </el-form-item>
                        </el-col>
                        <el-col :span="12">
                    <el-form-item label="注销标记:" prop="isCancel">
                        <el-select v-model="form.isCancel" placeholder="请选择" size="small">
                            <el-option label="全部"  value="全部"></el-option>
                            <el-option label="正常"  value='0'></el-option>
                            <el-option label="已注销"  value='1'></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>-->
                <el-col :span="12">
                    <el-form-item label="许可证号:" prop="xkzh">
                        <el-input v-model="form.xkzh" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="许可项目:" prop="xkxm">
                        <el-input v-model="form.xkxm" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <!--         <el-col :span="12">
                    <el-form-item label="有效期:" prop="xkzyxq">
                        <el-input v-model="form.xkzyxq" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="定位信息:" prop="gps">
                        <el-input v-model="form.gps" clearable size="small" placeholder="请输入" style="width:calc(100% - 100px);"></el-input>
                        &nbsp;<el-button  size="small" type="warning" @click="getWz()">查</el-button>
                    </el-form-item>
                </el-col> -->
                        <el-col :span="12">
                    <el-form-item label="民族:" prop="nation">
                        <el-select v-model="form.nation" placeholder="请选择民族" size="small" >
                            <el-option
                                v-for="dict in mzOptions"
                                :key="dict.id"
                                :label="dict.nation"
                                :value="dict.nation"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                
                <el-col :span="12">
                    <el-form-item label="证件类型:" prop="zjType">
                        <el-select v-model="form.zjType" placeholder="请选择" size="small" >
                            <el-option label="居民身份证"  value="居民身份证"></el-option>
                            <el-option label="港澳台通行证"  value="港澳台通行证"></el-option>
                            <el-option label="台湾居民来往大陆通行证号码"  value="台湾居民来往大陆通行证号码"></el-option>
                            <el-option label="护照"  value="护照"></el-option>
                            <el-option label="回乡证"  value="回乡证"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                        <el-col :span="12">
                    <el-form-item label="证件号码:" prop="sfzh">
                        <el-input
                        v-model="form.sfzh"
                        placeholder="请输入"
                        clearable
                        size="small"
                        
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="身份地址:" prop="zhuzhi">
                        <el-input v-model="form.zhuzhi" clearable size="small" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>    
                        
                        
                    </el-row>
                </el-form>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button  size="small" type="primary" @click="onSubmit('form')">确定</el-button>
                    <el-button  size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            cmid:'',
            dm:'',
            sheng:'',
            shi:'',
            xianqu:'',
            queryParams:{
                dwmc:'',
                zylb:'',
                page:1,
                limit:10,
            },
            total:0,
            xdrList:[],
            zylbOptions:[],
            checkList:[],
            open:false,
            pageshow:true,
            form:{
                jingyingzhe:'法定代表人',
                jingyingzheXm:'',
                zw:'院长',
                frxb:'男',
                dwmc:'',
                dwdz:'',
                sj1:'',
                zylb:'',
                zjType:'居民身份证',
                isCancel:'0',
            },
            rules:{
                jingyingzhe:[
                    { required: true, message: '经营者不能为空', trigger: ['change','blur'] }
                ],
                jingyingzheXm:[
                    { required: true, message: '经营者姓名不能为空', trigger: 'blur' }
                ],
                frzw:[
                    { required: true, message: '职务不能为空', trigger: ['change','blur'] }
                ],
                frxb:[
                    { required: true, message: '性别不能为空', trigger: ['change','blur'] }
                ],
                dwmc:[
                    { required: true, message: '单位(个人)名称不能为空', trigger: 'blur' }
                ],
                zylb:[
                    { required: true, message: '专业类别不能为空', trigger: ['change','blur'] }
                ],
                nation:[
                    { required: true, message: '民族不能为空', trigger: ['change','blur'] }
                ],
            },
            jingyingzheOptions:[],
            zwOptions:[],
            jjlxOptions:[],
            mzOptions:[],
            zjlxOptions:[],
            qyOptions:[],
            gzbmOptions:[],
            sc: "",
            xg: "",
            xz: "",
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '相对人' || ele.item == '被监管对象管理'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.dm = user.dm
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.sheng = user.sheng
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/selectFaRenType`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid,
            }
        })
        .then(response => {
            console.log(response.data,1194)
            if (response.data && response.data.data) {
                this.jingyingzheOptions = response.data.data;
            }else{
                this.jingyingzheOptions = []
            }
            this.loading = false
        })
        .catch(error => {
            this.loading = false
            this.$message.error('获取数据失败！');
            console.error('There was an error!', error);
        }); 
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getzhiwu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zwOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })   
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions =  res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        }) 
        this.getList()
    },
    methods: {
        getList(){
            this.loading = false
            this.xdrList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/xiangduiren`,
                data:{
                    zylb:this.queryParams.zylb,
                    dwmc:this.queryParams.dwmc,
                    cmid:this.cmid,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.xdrList = res.data.data.list
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.loading = false
                this.$message.error(error);
            })
        },
        async getTb(){
            //同步
            this.loading = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=setjbxxtb&c_mid=${this.cmid}&dwmc=&type=2`)
            if(data.data){
                
                console.log(data.data)
                if(data.data[0].errcode == -1){
                    this.loading = false
                    this.$message.error(data.data[0].errMessage)
                }else if(data.data[0].errcode == 0){
                    // this.$forceUpdate()
                    this.getList()
                    this.loading = false
                    this.$message({
                        message: data.data[0].errMessage,
                        type: 'success'
                    });
                }
            }
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){
            this.open = true
        },
        getCheck(){
            console.log(this.checkList)
        },
        handleSelect(row){
            this.$router.push({path:'/daxq',query:{id:row.id}})
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                zylb:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        getWZ(){},
        cancel(){
            this.open = false
            this.form = {}
        },
        onSubmit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if(this.form.ID){
                        axios({
                            method: 'post',
                            url: this.baseUrl+`/login/editYouOrWu`,
                            data:{
                                id: this.form.ID,
                                wz:0,
                                jingyingzhe: this.form.jingyingzhe,
                                jingyingzheXm: this.form.jingyingzheXm,
                                fzr: this.form.jingyingzheXm,
                                frzw: this.form.frzw,
                                frxb: this.form.frxb,
                                dwmc: this.form.dwmc,
                                dwdz: this.form.dwdz,
                                sheng: this.sheng,
                                shi: this.shi,
                                xianqu: this.xianqu,
                                xiangjiedao: this.form.xiangjiedao,
                                sj1: this.form.sj1,
                                zylb: this.form.zylb,
                                zyzlb: '',
                                zzdm: this.form.zzdm,
                                xkzh: '',
                                xkxm: '',
                                xkzyxq: '',
                                gps: '',
                                nation: this.form.nation,
                                zhuzhi: this.form.zhuzhi,
                                sfdz: this.form.sfdz,
                                zjType: '',
                                sfzh: this.form.sfzh,
                                isCancel: '',
                                jjlx: '',
                                changsuo: this.form.changsuo,
                                wfxwdz: this.form.wfxwdz,
                            },
                            headers: { 
                                "Content-Type": "application/json"
                            },
                        }).then(res => {
                            console.log(res)
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.getList()
                            this.open = false
                        }).catch(res => {
                            this.$message({
                                message: '修改失败',
                                type: 'error'
                            });
                        })
                    }else{
                        axios({
                            method: 'post',
                            url: this.baseUrl+`/login/savexiangduiren`,
                            data:{
                                cmid: this.cmid,
                                operatorDm: this.dm,
                                jingyingzhe: this.form.jingyingzhe,
                                jingyingzheXm: this.form.jingyingzheXm,
                                frzw: this.form.frzw,
                                frxb: this.form.frxb,
                                dwmc: this.form.dwmc,
                                dwdz: this.form.dwdz,
                                sheng: this.sheng,
                                shi: this.shi,
                                xianqu: this.xianqu,
                                xiangjiedao: '',
                                sj1: this.form.sj1,
                                zylb: this.form.zylb,
                                zyzlb: '',
                                zzdm: this.form.zzdm,
                                xkzh: this.form.xkzh,
                                xkxm: this.form.xkxm,
                                xkzyxq: this.form.xkzyxq,
                                gps: this.form.gps,
                                nation: this.form.nation,
                                sfdz: this.form.zhuzhi,
                                zjType: this.form.zjType,
                                sfzh: this.form.sfzh,
                                isCancel: this.form.isCancel,
                                jjlx: this.form.jjlx,
                            },
                            headers: { 
                                "Content-Type": "application/json"
                            },
                        }).then(res => {
                            console.log(res)
                            this.$message({
                                message: '新增成功',
                                type: 'success'
                            });
                            this.getList()
                            this.open = false
                        }).catch(res => {
                            this.$message({
                                message: '新增失败',
                                type: 'error'
                            });
                        })
                    }
                }
            })
        },
        handleEdit(row){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getIdYouOrWu`,
                data:{
                    id:row.ID,
                    wz:0
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                console.log(res)
                this.open = true
                this.form = res.data.data || {}
            }).catch(res => {
                this.$message({
                    message: '获取数据失败，请联系管理员！',
                    type: 'error'
                });
            })
        },
        handleDelete(row){
            this.$confirm("您确认要删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/deleteYouOrWu`,
                    data:{
                        id: row.ID,
                        wz:0
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    this.open = false
                    if(res.data.code == 0 && res.data.data){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getList()
                    }else{
                        if(res.data.msg){
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(error => {
                    this.$message.error(error);
                })   
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        }
    }
}
</script>


<style scoped>
.bq >>> .el-form-item__label{line-height: 20px;}
.content >>>    .el-loading-spinner{
  font-size: 100px;
}
</style>